/** GxSpectrum: a labelled position on a two-ended scale (liability-sensitive ◀──●──▶ asset-sensitive); `value` runs −1 (left end) to +1 (right end). */
export function GxSpectrum({ value, left, right, word }: { readonly value: number; readonly left: string; readonly right: string; readonly word: string }) {
  const at = ((Math.max(-1, Math.min(1, value)) + 1) / 2) * 100;
  return (
    <div className="gx-spectrum" role="img" aria-label={`${word}: ${Math.round(at)}% of the way from ${left} to ${right}`}>
      <div className="gx-spectrum-ends gx-small"><span>◀ {left}</span><span>{right} ▶</span></div>
      <div className="gx-spectrum-track"><span className="gx-spectrum-mid" /><span className="gx-spectrum-dot" style={{ left: `${at}%` }} /></div>
      <div className="gx-spectrum-word">{word}</div>
    </div>
  );
}
